// Settings sub-layout — mounts `SettingsShell` (sub-nav + content column)
// under the `_authed` shell.

import { Outlet, createRoute } from '@tanstack/react-router';

import { SettingsShell } from '@/features/settings/SettingsShell';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'settings',
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <SettingsShell>
      <Outlet />
    </SettingsShell>
  );
}
